import React from "react";

import { Slider as ShadcnSlider } from "@replo/design-system/components/shadcn/core/slider";
import twMerge from "@replo/design-system/utils/twMerge";

type SliderProps = {
  disabled?: boolean;
  id?: string;
  onChange?: (value: number[]) => void;
  layoutClassName?: string;
  UNSAFE_className?: string;
  rangeClassName?: string;
  trackClassName?: string;
  thumbClassName?: string;
  thumbIcon?: React.ReactNode;
  thumbTooltip?: React.ReactNode;
  value?: number[];
  defaultValue?: number[];
  min?: number;
  max?: number;
  step?: number;
  onKeyDown?: (event: React.KeyboardEvent<HTMLSpanElement>) => void;
};

const Slider: React.FC<SliderProps> = ({
  disabled = false,
  id,
  onChange,
  value,
  defaultValue = [0],
  min = 0,
  max = 100,
  step = 1,
  layoutClassName,
  UNSAFE_className,
  rangeClassName,
  trackClassName,
  thumbClassName,
  thumbIcon,
  thumbTooltip,
  onKeyDown,
}) => {
  return (
    <ShadcnSlider
      id={id}
      className={twMerge(
        "w-full",
        disabled && "cursor-not-allowed opacity-50",
        layoutClassName,
        UNSAFE_className,
      )}
      rangeClassName={rangeClassName}
      trackClassName={trackClassName}
      thumbClassName={thumbClassName}
      thumbIcon={thumbIcon}
      thumbTooltip={thumbTooltip}
      value={value}
      defaultValue={defaultValue}
      min={min}
      max={max}
      step={step}
      onValueChange={onChange}
      onKeyDown={onKeyDown}
      disabled={disabled}
    />
  );
};

/** @public */
export type { SliderProps };
export { Slider };
